<p class="subheading">Accounts</p>
<div class="pad-top-20">
  You've selected {{ options.length }} account
  @if (options.length !== 1) {
    s
  }
  .
</div>
@for (option of options; track option) {
  <div class="paymentAccount">
    <div class="account">
      <amfam-account-description-minimal [option]="option"> </amfam-account-description-minimal>
      <div class="paymentAmount leftpad">
        <p>Payment Amount</p>
        <label data-cy="selectedPaymentAmount" [ngClass]="{ warning: option.helpText.warning }">{{
          option.selectedPaymentAmount | currencyUSD
        }}</label>
        @if (option?.helpText.errorText) {
          <div class="errorMessage">
            <span class="icon-alert"></span>
            <p class="pad-left-5 errorText">{{ option?.helpText.errorText }}</p>
          </div>
        }
      </div>
      <div class="paymentAmount card-action">
        <!-- AS: TODO check this id and why are we using it-->
        <button
          ds-button
          class="-outline-white"
          [class.capitalize]="false"
          (click)="edit(option?.billAccountNumber)"
        >
          <span class="icon icon-pen" data-cy="editPaymentAmountButton">
            <p class="icon-text">Edit Amount</p>
          </span>
        </button>
        @if (options?.length > 1) {
          <button
            ds-button
            class="-outline-white"
            [class.capitalize]="false"
            (click)="delete(option?.billAccountNumber)"
          >
            <span class="icon icon-trash deletePaymentMargin">
              <p class="icon-text">Delete Payment</p>
            </span>
          </button>
        }
      </div>
    </div>
  </div>
}
@if (showAutoPaySetUpLink) {
  <a (click)="setupAutopay()">{{ linkText }}</a>
}
